export default __webpack_public_path__ + "static/media/Baumer.19972fcf.jpeg";